import { Check } from "lucide-react";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  labels: string[];
}

export default function StepIndicator({ currentStep, totalSteps, labels }: StepIndicatorProps) {
  return (
    <div className="w-full">
      {/* Progress bar */}
      <div className="h-1 bg-slate-100 rounded-full mb-6 overflow-hidden">
        <div
          className="h-full bg-blue-800 rounded-full transition-all duration-500"
          style={{ width: `${((currentStep) / totalSteps) * 100}%` }}
        />
      </div>

      {/* Steps */}
      <div className="flex items-start justify-between">
        {labels.map((label, i) => {
          const stepNum = i + 1;
          const isDone = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <div key={label} className="flex flex-col items-center flex-1">
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full border-2 transition-all mb-2 ${
                  isDone
                    ? "bg-blue-800 border-blue-800 text-white"
                    : isActive
                    ? "bg-white border-blue-800 text-blue-800"
                    : "bg-white border-slate-200 text-slate-400"
                }`}
              >
                {isDone ? (
                  <Check size={14} />
                ) : (
                  <span className="text-xs font-bold">{stepNum}</span>
                )}
              </div>
              <span className={`text-xs font-medium text-center hidden sm:block ${
                isActive ? "text-blue-800" : isDone ? "text-slate-600" : "text-slate-400"
              }`}>
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}